import axios from 'axios';
import {
  Box,
  Button,
  ButtonGroup,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React, {
  Dispatch,
  ChangeEvent,
  useEffect,
  useRef,
  useState,
} from 'react';
import { QueryCache, useMutation, useQuery, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';
import { useRecoilState } from 'recoil';
import clsx from 'clsx';
import { startOfYear } from 'date-fns';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import SearchIcon from '@mui/icons-material/Search';
import { useSession, xapi } from '../../hooks/session';
import { SwSnackbar } from '../commonComponent/views/SwSnackbar';
import SwLoading from '../commonComponent/spinner/SwLoading';
import { SwPagination } from '../commonComponent/tableElement/SwPagination';
import {
  encodeSearchWord,
  firstDayOfMonth,
  getCurrentStartDate,
  getDateList,
  lastDayOfMonth,
  timestamp2Localestring,
} from '../../common/helper';
import {
  KEY_CLASS_WRITE_LIST,
  KEY_PORTAL,
  KEY_PORTAL_WRITE_LIST,
  KEY_READ_TEXT,
  KEY_WALK_TEXT,
  KEY_WRITE_TEXT,
} from '../../common/key';
import excellog from '../../images/sub/excel_icon.svg';
import { SwBookGroup } from '../commonComponent/SwBookGroup';
import { SwBookList } from '../commonComponent/SwBookList';
import { uploadFile } from '../../common/api/ApiUpload';
import { RESULT_OK } from '../../common/resultCode';
import { SwClassStatTab } from '../commonComponent/SwClassStatTab';
import { SwUserStatDetail } from '../commonComponent/SwUserStatDetail';
import { SwSelectMonth } from '../commonComponent/SwSelectMonth';
import {
  downloadClassRankList,
  downloadClassWriteList,
  getClassWriteList,
} from '../../common/api/ApiClassStat';
import { selectSchoolInfoState } from '../../common/atom';
import { SwUserWriteCard } from '../commonComponent/SwUserWriteCard';
import { SwPortalStatTab } from '../commonComponent/SwPortalStatTab';
import {
  downloadPortalWriteList,
  getPortalWriteList,
} from '../../common/api/ApiPortal';

interface Props {}

export const PortalLogManage: React.FC<Props> = () => {
  const { loginVal } = useSession();

  const [schoolClassInfo, setSchoolClassInfo] = useState<any>();
  const [reqRequest, setReqRequest] = useState<boolean>(false);
  const [wirteList, setWriteList] = useState<any[]>([]);
  const [loading, setLoading] = useState<any>(false);
  const [targetMonth, setTargetMonth] = useState<any>(getCurrentStartDate());
  const [targetDay, setTargetDay] = useState<any>(0);
  const [rangeDate, setRangeDate] = useState([
    startOfYear(new Date()), // 올해 1월 1일
    new Date(), // 오늘
  ]);

  const rowsPerPageOptions = [5, 10, 15, 20];
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const [searchKey, setSearchKey] = useState<string>('book-group');
  const [searchWord, setSearchWord] = useState<string>('');
  const [dialogMessage, setDialogMessage] = useState<string>('');
  const [openSnackbar, setOpenSnackbar] = useState<boolean>(false);
  const [openUserStat, setOpenUserStat] = useState<boolean>(false);

  const {
    data,
    isLoading,
    refetch: refetchPortalWriteList,
  } = useQuery(
    KEY_PORTAL_WRITE_LIST,
    () => {
      if (reqRequest) {
        const newData: any = {
          page: page,
          rowsPerPage: rowsPerPage,
          searchKey: searchKey,
          searchWord: encodeSearchWord(searchKey, searchWord),
          startDate: rangeDate[0] === null ? 0 : rangeDate[0].getTime(),
          endDate: rangeDate[1] === null ? 0 : rangeDate[1].getTime(),
        };
        return getPortalWriteList(newData);
      }
      return null;
    },
    {
      onSuccess: res => {
        setLoading(false);
        if (res && res.statList) {
          setWriteList(res.statList);
          setTotalRecords(res.totalRecordCount);
        }
      },
      onError: e => {
        setLoading(false);
        console.log(e);
      },
    }
  );

  const loadClassStat = () => {
    setLoading(true);
    refetchPortalWriteList();
  };

  // const downloadPortalWriteList = async (param: any) =>
  //   xapi
  //     .get(
  //       `/admin/v1/apis/portal-stat/all-write-status/download?page=${param.page}&perPage=${param.rowsPerPage}&searchKey=${param.searchKey}&searchWord=${param.searchWord}&startDate=${param.startDate}&endDate=${param.endDate}`,
  //       { responseType: 'blob' }
  //     )
  //     .then(res => {
  //       const blob = new Blob([res.data]);
  //       const url = window.URL.createObjectURL(blob);
  //       const a = document.createElement('a');
  //       a.href = url;
  //       a.download = 'portal_stat_log.xlsx';
  //       document.body.appendChild(a);
  //       a.click();
  //       setTimeout(() => {
  //         window.URL.revokeObjectURL(url);
  //       }, 60000);
  //       a.remove();
  //     })
  //     .catch(err => {
  //       console.error('err: ', err);
  //       throw err; // 재던짐
  //     });

  const downloadLog = async () => {
    const newData: any = {
      page: 0,
      rowsPerPage: 0,
      searchKey: searchKey,
      searchWord: encodeSearchWord(searchKey, searchWord),
      startDate: rangeDate[0] === null ? 0 : rangeDate[0].getTime(),
      endDate: rangeDate[1] === null ? 0 : rangeDate[1].getTime(),
    };
    setLoading(true);
    try {
      await downloadPortalWriteList(newData);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeStepPage = (_event: any, newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (reqRequest) {
      loadClassStat();
    }
  }, [page]);

  useEffect(() => {
    if (reqRequest) {
      loadClassStat();
    }
  }, [targetMonth, targetDay]);

  useEffect(() => {
    reqRequest && loadClassStat();
  }, [reqRequest]);

  useEffect(() => {
    setReqRequest(true);
  }, []);

  return (
    <>
      <Paper sx={{ p: '1.5rem' }}>
        <SwPortalStatTab
          tabValue={4}
          schoolClassInfo={schoolClassInfo}
          setSchoolClassInfo={setSchoolClassInfo}
        />
        <Box>
          <Box className='flex_end'>
            <Button
              sx={{ ml: '1rem' }}
              color='info'
              variant='outlined'
              onClick={() => downloadLog()}
            >
              데이터 다운로드
              <FileDownloadRoundedIcon color='success' />
            </Button>
          </Box>
          <Grid container spacing={2}>
            {wirteList &&
              wirteList.map((writeInfo: any, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <SwUserWriteCard type={KEY_PORTAL} writeInfo={writeInfo} />
                </Grid>
              ))}
          </Grid>
          {wirteList && wirteList.length > 0 && (
            <SwPagination
              page={page}
              handleChangePage={handleChangeStepPage}
              count={Math.ceil(totalRecords / rowsPerPage)}
            />
          )}
        </Box>
        {loading && <SwLoading />}
      </Paper>
      <SwSnackbar
        open={openSnackbar}
        onClose={() => setOpenSnackbar(false)}
        contents={dialogMessage}
      />
      <SwUserStatDetail
        memberSeq={1}
        open={openUserStat}
        onClose={() => setOpenUserStat(false)}
      />
    </>
  );
};
